import { AxiosResponse } from 'axios'
import { IRequisiteHistoryErrors } from '../../../common/api/error.types'
import { IExternalUserFlagsError, IRequisiteHistoryResponse } from './logs.types'
import { getErrorResponse } from '../../../common/api/errors'

export const isApiErrorTicketToken = (
  error: unknown
): error is AxiosResponse<IRequisiteHistoryErrors<IRequisiteHistoryResponse>> => {
  return typeof getErrorResponse<IRequisiteHistoryResponse>(error)?.paymentTicketToken === 'string'
}

export const isApiErrorExternalUserFlags = (
  error: unknown
): error is AxiosResponse<IExternalUserFlagsError> => {
  const errorResponse = getErrorResponse<IExternalUserFlagsError>(error)
  return !!(errorResponse?.errors && 
    (typeof errorResponse.errors.general_error === 'string' || 
     typeof errorResponse.errors.userId === 'string' || 
     Object.keys(errorResponse.errors).length > 0))
}
